<app-notifications></app-notifications>
<ng-container *ngIf="type === 'officefse'">
    <router-outlet></router-outlet>
</ng-container>

<div class="content-wrapper" *ngIf="type !== 'officefse'">
    <div class="backdrop" *ngIf="isUserPanelOpen" (click)="closeUserPanel()"></div>
    <div class="link-header">
        <div class="links-name">
            <div class="logo" *ngIf="!showBackButton">
                    <a class="navbar-brand" href="https://www.sync.com/?_m=h73">
                        <img
                            *ngIf="whiteLabelLoaded && !imageCachekey"
                            id="navbar-logo"
                            class="navbar-white-q"
                            src="assets/images/sync-logo-links.svg"
                        />
                        <img
                            *ngIf="whiteLabelLoaded && imageCachekey"
                            id="navbar-logo"
                            class="navbar-white-q logo-custom"
                            [src]="logoHost + imageCachekey" />
                    </a>
            </div>
            <div class="back-button" *ngIf="showBackButton">
                <sync-icon-button iconName="arrow-left" [onClick]="onBack" matTooltip="Back" type="primary"></sync-icon-button>
            </div>
            <div class="title-area">
                <div class="name-and-actions">
                    <div class="title h5">
                        <div class="display-grid">
                            <div class="ellipses">
                                {{title}}
                            </div>
                        </div>
                    </div>
                    <div class="trail-actions">
                        <sync-action-cell
                            *ngIf="previewActionCell"
                            [actions]="previewActionCell.actions"
                            [limit]="actionLimit"
                            [rowData]="previewActionCell.rowData"
                            [showActionsInBottomSheet]="isXsView || isSmView"
                            [bottomsheetTemplate]="bottomsheetTemplate"
                        ></sync-action-cell>
                        <div class="vertical-devider" *ngIf="!isXsView">
                            <sync-divider></sync-divider>
                        </div>
                        <ng-container *ngIf="!isXsView && !isSmView">
                            <sync-icon-button iconName="help" [onClick]="helpClick" matTooltip="Help" type="primary"></sync-icon-button>
                        </ng-container>

                        <div class="user-info" *ngIf="!isXsView">
                            <div class="user-info-container" *ngIf="user && user.exists && userLoaded">
                                <sync-avatar [size]="48" [url]="avatarUrl" [initials]="(user?.display_name | b64)" [onClick]="openUserPanel"></sync-avatar>
                                <div class="user-panel" [class.show]="isUserPanelOpen">
                                    <app-user-panel [isPublink]="true"></app-user-panel>
                                </div>
                                <sync-bottom-sheet #bottomSheetComponent *ngIf="isBottomSheetOpen" type="primary">
                                    <app-user-panel [bottomSheet]="bottomSheetComponent" class="user-panel-bottom" [isPublink]="true"></app-user-panel>
                                </sync-bottom-sheet>
                            </div>
                            <div class="create-account-container" *ngIf="(!user || !user.exists) && userLoaded">
                                <a class="navbar-brand" href="https://www.sync.com/?_m=h73">
                                    <sync-button
                                        type="filled"
                                        label="Create Account">
                                    </sync-button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="secondary-info body-2">
                    <div class="display-grid">
                        <div class="ellipses">
                            {{subTitle}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="link-content">
        <div class="content" [class.expand-content]="!isCommentExpanded">
            <router-outlet></router-outlet>
        </div>
        <app-comment-block
            [class.hide]="!allowComment"
            (commentExpandChange)="isCommentExpanded = $event"
        ></app-comment-block>
    </div>

    <sync-snackbar *ngFor="let data of snackbarService?.snackbarData"
    [type]="data?.type"
    [message]="data?.message"
    [config]="data?.config"
    [shouldDismissAfterAction]="data?.shouldDismissAfterAction"
    [leadAdornmentConfig]="data?.leadAdornmentConfig"
    [trailAdornmentConfig]="data?.trailAdornmentConfig"
    [onAction]="$any(data?.trailAdornmentConfig?.buttonConfig?.onClick)"
    ></sync-snackbar>

    <ng-template #bottomsheetTemplate>
        <a [href]="cpHost + '/account/info'" style="text-decoration: none;">
            <sync-menu-item
                *ngIf="user && user.exists && userLoaded && isXsView"
                [menuItem]="{
                    name: (user?.display_name | b64),
                    value: user,
                    description: true,
                    descriptionContent: 'Signed in',
                    leadSpace: true,
                    leadAdornmentConfig: {
                        enabled: true,
                        size: 'large',
                        type: 'avatar',
                        avatarConfig: {
                            type: 'avatar',
                            size: 40,
                            url: avatarUrl,
                            initials: (user?.display_name | b64),
                            randomColor: true
                        }
                    },
                    divider: true
                }"
            ></sync-menu-item>
        </a>
    </ng-template>
</div>
<app-help-link-dialog [(openHelpLinkDialog)]="openHelpLinkDialog"></app-help-link-dialog>